// extracted by mini-css-extract-plugin
export default {"wrapper":"SkeletonMessages_wrapper__Dl08T"};